import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createSlots as _createSlots, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13919e46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search" }
const _hoisted_2 = {
  key: 0,
  class: "operation"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 刷新 ")
const _hoisted_4 = { class: "tree" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { style: {"color":"#f50"} }
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any) {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_SyncOutlined = _resolveComponent("SyncOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_UpOutlined = _resolveComponent("UpOutlined")!
  const _component_down_outlined = _resolveComponent("down-outlined")!
  const _component_JsxTemp = _resolveComponent("JsxTemp")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_tree = _resolveComponent("a-tree")!

  return (_openBlock(), _createElementBlock("div", {
    id: "treeView",
    style: _normalizeStyle(_ctx.treeOptions.treeStyle)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.treeConfig.filter)
        ? (_openBlock(), _createBlock(_component_a_input_search, {
            key: 0,
            size: "small",
            value: _ctx.searchTreeKey,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTreeKey) = $event)),
            placeholder: "关键字"
          }, null, 8, ["value"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.treeConfig.operation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_a_button, {
            class: "oBtn",
            type: "primary",
            size: "small",
            onClick: _ctx.refresh
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SyncOutlined),
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            class: "oBtn",
            type: "primary",
            size: "small",
            onClick: _ctx.open
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_DownOutlined, null, null, 512), [
                [_vShow, _ctx.expandState]
              ]),
              _withDirectives(_createVNode(_component_UpOutlined, null, null, 512), [
                [_vShow, !_ctx.expandState]
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.expandState ? "折叠" : "展开"), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_a_tree, _mergeProps({
        blockNode: true,
        showLine: _ctx.treeConfig.showLine,
        size: "small",
        replaceFields: _ctx.treeOptions.treeField,
        selectedKeys: _ctx.selDept,
        "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selDept) = $event)),
        showIcon: _ctx.treeConfig.showIcon,
        "expanded-keys": _ctx.expandedKeys
      }, _ctx.treeConfig._attr, {
        "tree-data": _ctx.treeData,
        onExpand: _ctx.onExpand,
        onSelect: _ctx.selTreeNode,
        defaultExpandAll: false,
        autoExpandParent: _ctx.treeOptions.autoExpandParent,
        key: _ctx.key
      }), _createSlots({
        switcherIcon: _withCtx(() => [
          _createVNode(_component_down_outlined)
        ]),
        title: _withCtx((scope) => [
          _createVNode(_component_a_dropdown, {
            trigger: ['contextmenu'],
            disabled: _ctx.treeConfig.rightMenu.length == 0
          }, {
            overlay: _withCtx(() => [
              _createVNode(_component_a_menu, {
                size: "small",
                onClick: 
                  ({ key: menuKey }) => _ctx.treeNodeContextMenuClick(scope, menuKey)
                
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.treeConfig.rightMenu, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.key
                    }, [
                      (
                      item.hasOwnProperty('noShow') ? !item.noShow(scope) : true
                    )
                        ? (_openBlock(), _createBlock(_component_a_menu_item, {
                            disabled: 
                      item.hasOwnProperty('disabled')
                        ? item.disabled(scope)
                        : false
                    ,
                            key: item.key
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            default: _withCtx(() => [
              (
                scope[this.treeConfigs.majorName].indexOf(_ctx.searchTreeKey) > -1
              )
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    _createTextVNode(_toDisplayString(scope[_ctx.treeConfigs.majorName].substr(
                  0,
                  scope[_ctx.treeConfigs.majorName].indexOf(_ctx.searchTreeKey)
                )) + " ", 1),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.searchTreeKey), 1),
                    _createTextVNode(" " + _toDisplayString(scope[_ctx.treeConfigs.majorName].substr(
                  scope[_ctx.treeConfigs.majorName].indexOf(_ctx.searchTreeKey) +
                    _ctx.searchTreeKey.length
                )), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(scope[_ctx.treeConfigs.majorName]), 1))
            ]),
            _: 2
          }, 1032, ["disabled"])
        ]),
        _: 2
      }, [
        _renderList(_ctx.slotIconList, (item, index) => {
          return {
            name: item.icon,
            fn: _withCtx((node) => [
              _renderSlot(_ctx.$slots, item.icon, {
                key: node[_ctx.treeConfigs.majorKey],
                selected: node.selected
              }, undefined, true)
            ])
          }
        }),
        _renderList(_ctx.iconList, (item, index) => {
          return {
            name: item.key,
            fn: _withCtx(() => [
              (item.icon)
                ? (_openBlock(), _createBlock(_component_JsxTemp, {
                    key: 0,
                    icon: item.icon
                  }, null, 8, ["icon"]))
                : _createCommentVNode("", true)
            ])
          }
        })
      ]), 1040, ["showLine", "replaceFields", "selectedKeys", "showIcon", "expanded-keys", "tree-data", "onExpand", "onSelect", "autoExpandParent"])
    ])
  ], 4))
}